(function() {
    angular
        .module("apiModule", [
            "ui.router"
        ])
})()
